import type {
  SearchPersonResult,
  SearchOrganizationResult,
  SearchTaskResult,
} from '../types';

const KEY = 'crm.globalSearch.recent';
const MAX = 5;

export type RecentSearchItem =
  | { type: 'person'; data: SearchPersonResult; selectedAt: number }
  | { type: 'organization'; data: SearchOrganizationResult; selectedAt: number }
  | { type: 'task'; data: SearchTaskResult; selectedAt: number };

export function getRecentSearches(): RecentSearchItem[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function pushRecentSearch(item: Omit<RecentSearchItem, 'selectedAt'>): void {
  const id = item.data.id;
  const current = getRecentSearches().filter((r) => !(r.type === item.type && r.data.id === id));
  const next: RecentSearchItem[] = [
    { ...item, selectedAt: Date.now() } as RecentSearchItem,
    ...current,
  ].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // localStorage may be unavailable (private mode, quota exceeded) — silently no-op
  }
}

export function clearRecentSearches(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
